import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../i18n/LanguageContext';
import { patientStatusLabel, statusOf } from './patientStatuses';

/** Coloured pill for a patient status. */
const PatientStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const definition = statusOf(status);
  return (
    <span className={`tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold ${definition ? definition.tone : 'tw-bg-slate-500/10 tw-text-slate-600 dark:tw-text-slate-300'}`}>
      <span aria-hidden="true" className={`tw-h-1.5 tw-w-1.5 tw-rounded-full ${definition ? definition.dot : 'tw-bg-slate-400'}`} />
      {patientStatusLabel(t, status)}
    </span>
  );
};

PatientStatusBadge.propTypes = { status: PropTypes.string };

export default PatientStatusBadge;
